<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="hasNegativeBalance ? 'Subscription Payment Issue' : 'Change Subscription'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      @if (isMobileResolution || isRightSideContent) {
        @if (hasNegativeBalance || isAccountSuspended) {
          <tidy-row>
            <tidy-alert>
              <tidy-row>
                <tidy-image [src]="'assets/img/black-alert.svg'" />
                <tidy-text [header]="hasNegativeBalance ? 'Your Subscription Payment Failed' : 'Plan Canceled Due to Failed Payment'"/>
              </tidy-row>
              <tidy-row>
                <tidy-text [body]="hasNegativeBalance ? 'Please select a payment method and confirm your subscription.' : 'Please select a payment method and a subscription.'"/>
              </tidy-row>
            </tidy-alert>
          </tidy-row>
          <tidy-row [align]="'center'" class="extra-top-padding">
            <tidy-text [body]="'Select your payment method:'" />
          </tidy-row>
          <tidy-card>
            <tidy-row>
              <form [formGroup]="form">
                <tidy-row>
                  <tidy-text [header]="'Payment Method'" />
                </tidy-row>
                <tidy-radio-button
                  formControlName="howToPay"
                  [form]="form.controls.howToPay"
                  [items]="howToPayItems"
                  [submitted]="submitted"
                  [errorMessage]="'Please select a payment method.'" />
              </form>
            </tidy-row>
            @if (form?.value?.howToPay === 'newCard') {
              <div class="form-row">
                <div id="card-info" #cardInfo></div>
              </div>
              <div style="display: flex; align-content: center; justify-content: center;">
                <re-captcha (resolved)="captchaEvents($event)" />
              </div>
              @if (captchaErrorMessage) {
                <tidy-error-message
                  [text]="'Please check that you are not a robot.'" />
              }
            }
          </tidy-card>
        }
        @if (hasCustomSubscription) {
          <tidy-card [ngClass]="selectedSubscription?.key === 'custom' ? 'subscription-card light-black-background' : 'subscription-card'">
            <tidy-row>
              <tidy-text
                [header]="'Custom Subscription:'" /><span>&nbsp;</span>
                <tidy-text
                  [header]="selectedSubscription?.plan?.description" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'You have a custom subscription. Please reach out to the concierge to make changes to your custom subscription.'" />
              </tidy-row>
            </tidy-card>
          }
          @if (!hasCustomSubscription) {
            <tidy-row [align]="'center'" [ngClass]="{'extra-top-padding': hasNegativeBalance}">
              <tidy-text [body]="'Select your subscription:'" />
            </tidy-row>
            <tidy-card [ngClass]="selectedSubscription?.key === 'flex' ? 'subscription-card light-black-background' : 'subscription-card'" (click)="selectSubscription('flex')">
              <tidy-row>
                <tidy-text
                  [title]="'Flex'" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [helper]="'Best for intermittent use, getting started, or when others pay.'"/>
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [title]="flexSubscription?.debit_strategies?.debit_fee_by_private_job?.fee_percent_by_job + '%'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'/ job'" />
                </tidy-row>
                @if (selectedSubscription?.key === 'flex') {
                  <tidy-row class="extra-top-padding">
                    <tidy-text
                      [body]="'Flex plan features:'" />
                  </tidy-row>
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/img/tick-2.svg'"
                      style="width: 12px"/>
                    <tidy-text
                      [body]="'Amazing operations software.'" />
                  </tidy-row>
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/img/tick-2.svg'"
                      style="width: 12px"/>
                    <tidy-text
                      [body]="'Schedule cleaning/maintenance anywhere.'" />
                  </tidy-row>
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/img/tick-2.svg'"
                      style="width: 12px"/>
                    <tidy-text
                      [body]="'No property fees. For completed jobs, pay 3% of the job cost (min $3, max $49).'" />
                  </tidy-row>
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/img/tick-2.svg'"
                      style="width: 12px"/>
                    <tidy-text
                      [body]="'Pay for Automation Credits as you use them.'" />
                  </tidy-row>
                }
              </tidy-card>

              <tidy-card [ngClass]="(selectedSubscription?.key === 'standard_yearly' || selectedSubscription?.key === 'standard_monthly') ? 'subscription-card light-black-background' : 'subscription-card'" (click)="selectSubscription('standard')">
                <tidy-row>
                  <tidy-text
                    [title]="'Standard'" />
                </tidy-row>
                <tidy-row class="extra-bottom-padding">
                  <tidy-text
                    [helper]="'Great for owners or managers who prefer to pay flat rates.'"/>
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [title]="(form?.value?.yearlyMonthly === 'yearly' ? standardYearlySubscription?.debit_strategies?.debit_by_address?.amount_by_address : standardMonthlySubscription?.debit_strategies?.debit_by_address?.amount_by_address) | tcurrency" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="('/ property' | translate) + (form?.value?.yearlyMonthly === 'yearly' ? (' / year' | translate) : (' / month' | translate))" />
                  </tidy-row>
                  @if (selectedSubscription?.key === 'standard_yearly' || selectedSubscription?.key === 'standard_monthly') {
                    <tidy-row>
                      <form [formGroup]="form">
                        <tidy-radio-button
                          formControlName="yearlyMonthly"
                          [form]="form.controls.yearlyMonthly"
                          [items]="[{value: 'yearly', viewValue: 'Pay Yearly (22% discount)'}, {value: 'monthly', viewValue: 'Pay Monthly'}]"
                          (optionChange)="selectStandardSubscription()" />
                      </form>
                    </tidy-row>
                    <tidy-row class="extra-top-padding">
                      <tidy-text
                        [body]="'Everything in Flex, plus:'" />
                    </tidy-row>
                    <tidy-row class="vertical-align-middle">
                      <tidy-image
                        [src]="'assets/img/tick-2.svg'"
                        style="width: 12px"/>
                      <tidy-text
                        [body]="'All software features.'" />
                    </tidy-row>
                    <tidy-row class="vertical-align-middle">
                      <tidy-image
                        [src]="'assets/img/tick-2.svg'"
                        style="width: 12px"/>
                      <tidy-text
                        [body]="'Unlimited automations.'" />
                    </tidy-row>
                    <tidy-row class="vertical-align-middle">
                      <tidy-image
                        [src]="'assets/img/tick-2.svg'"
                        style="width: 12px"/>
                      <tidy-text
                        [body]="'Pay for Automation Credits as you use them.'" />
                    </tidy-row>
                  }
                </tidy-card>

                <tidy-card [ngClass]="(selectedSubscription?.key === 'autopilot') ? 'subscription-card light-black-background' : 'subscription-card'" (click)="selectSubscription('autopilot')">
                  <tidy-row>
                    <tidy-text
                      [title]="'Autopilot (BETA)'" />
                  </tidy-row>
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text
                      [helper]="'Completely automate cleaning & maintenance.'"/>
                  </tidy-row>
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text
                      [title]="'9%'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'/ job'" />
                    </tidy-row>
                    @if (selectedSubscription?.key === 'autopilot') {
                      <tidy-row>
                        <tidy-text
                          [body]="'$99 / property / year minimum'" />
                      </tidy-row>
                      <tidy-row class="extra-top-padding">
                        <tidy-text
                          [body]="'Everything in Standard, plus:'" />
                      </tidy-row>
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/img/tick-2.svg'"
                          style="width: 12px"/>
                        <tidy-text
                          [body]="'Unlimited Automation Credits'" />
                      </tidy-row>
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/img/tick-2.svg'"
                          style="width: 12px"/>
                        <tidy-text
                          [body]="'Unlimited Find new pros'" />
                      </tidy-row>
                      <tidy-row class="vertical-align-middle extra-bottom-padding">
                        <tidy-image
                          [src]="'assets/img/tick-2.svg'"
                          style="width: 12px"/>
                        <tidy-text
                          [body]="'Virtual Assistant (for cleaning and maintenance)'" />
                      </tidy-row>
                      <tidy-button
                        [text]="'Talk to an Expert'"
                        [action]="goToLearnMoreAdvanced.bind(this)"
                        class="secondary" />
                    }
                  </tidy-card>
                }
                <tidy-row [align]="'center'" class="extra-bottom-padding">
                  <tidy-text
                    [actionBody]="'Learn more about each plan'"
                    class="link"
                    (action)="goToLearnMorePlans()" />
                </tidy-row>
                @if (selectedSubscription?.key === 'flex' || selectedSubscription?.key === 'standard_yearly' || selectedSubscription?.key === 'standard_monthly') {
                  <tidy-row [align]="'center'" class="extra-top-padding">
                    <tidy-text [body]="'Confirm your subscription:'" />
                  </tidy-row>
                  <tidy-card>
                    <tidy-row class="extra-bottom-padding vertical-align-center">
                      <tidy-image [src]="'assets/img/crown-black.svg'" />
                      <tidy-text [header]="selectedSubscription?.description + (' Plan' | translate)" />
                    </tidy-row>
                    @if (selectedSubscription?.key === 'flex') {
                      <tidy-row>
                        <tidy-text
                          [body]="selectedSubscription?.debit_strategies?.debit_fee_by_private_job?.fee_percent_by_job + '%'" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="'/ job (debited when the pro completes the job)'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="'Min fee per job: '" />
                          <tidy-text
                            [body]="selectedSubscription?.debit_strategies?.debit_fee_by_private_job?.min_fee_amount_by_job | tcurrency" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="'Max fee per job: '" />
                          <tidy-text
                            [body]="selectedSubscription?.debit_strategies?.debit_fee_by_private_job?.max_fee_amount_by_job | tcurrency" />
                        </tidy-row>
                      }
                      @if (selectedSubscription?.key === 'standard_yearly' || selectedSubscription?.key === 'standard_monthly') {
                        <tidy-row>
                          <tidy-text
                            [body]="('Total: ' | translate) + ((selectedSubscription?.debit_strategies?.debit_by_address?.amount_by_address * (numberOfPaidProperties || 0)) | tcurrency)" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="form?.value?.yearlyMonthly === 'yearly' ? '/ year' : '/ month'" />
                          </tidy-row>
                          <tidy-row>
                            <tidy-text
                              [body]="'Number of paid properties:'" /><span>&nbsp;</span>
                              <tidy-text
                                [body]="numberOfPaidProperties || '0'" />
                              @if (selectedSubscription?.debit_strategies?.debit_by_address?.number_of_free_addresses > 0) {
                                <tidy-text
                                  [body]="'(' + selectedSubscription?.debit_strategies?.debit_by_address?.number_of_free_addresses" /><span>&nbsp;</span>
                                  <tidy-text
                                    [body]="'free properties)'" />
                                }
                              </tidy-row>
                              <tidy-row>
                                <tidy-text
                                  [body]="'Cost per property:'" /><span>&nbsp;</span>
                                  <tidy-text
                                    [body]="(selectedSubscription?.debit_strategies?.debit_by_address?.amount_by_address) | tcurrency" /><span>&nbsp;</span>
                                    <tidy-text
                                      [body]="form?.value?.yearlyMonthly === 'yearly' ? '/ year' : '/ month'" />
                                  </tidy-row>
                                }
                              </tidy-card>
                            }
                            <tidy-button
                              [disabled]="(!hasNegativeBalance && selectedSubscription == currentSubscription) || selectedSubscription?.key === 'autopilot'"
                              [text]="hasNegativeBalance ? 'Pay Balance & Update Subscription' : 'Change Subscription Now'"
                              [action]="boundSave"
                              class="primary" />
                          }
                        }
                      </tidy-wrapper>
                    </ng-template>

                    @if (!isRightSideContent) {
                      <app-scroll-wrapper [templateContent]="content" />
                    }

                    @if (isRightSideContent) {
                      <ion-content class="ion-content-right-column">
                        <ng-container *ngTemplateOutlet="content" />
                      </ion-content>
                    }